import axios from 'axios';

export const SUPPORTS_STORAGE = typeof Storage !== 'undefined';

const parseAuthResponse = data => {
  let dataParsed = {};

  try {
    dataParsed = JSON.parse(data);
  } catch (e) {
    console.warn('error parsing auth token'); // eslint-disable-line no-console
  }

  return dataParsed;
};

const fetchAuthToken = async (baseAuthUrl, yyy) => {
  try {
    const response = await axios.get(`${baseAuthUrl}/auth?${yyy}`);
    const { access_token: token, expires_in: expiration } = parseAuthResponse(response.data) || {};

    if (SUPPORTS_STORAGE && token) {
      const d = new Date();
      d.setSeconds(d.getSeconds() + Number(expiration));
      localStorage.setItem('access_token', token);
      localStorage.setItem('token_expiration', d);
    }

    return token;
  } catch (e) {
    //console.log('there was an error', e.message)
    return null;
  }
};

const retrieveStoredAuthToken = (baseAuthUrl, yyy) => {
  //console.log('the retrieve bearer token in the service is = ', localStorage.getItem('access_token'));
  try {
    if (SUPPORTS_STORAGE) {
      const expiration = localStorage.getItem('token_expiration');
      const currentTime = new Date();
      const expirationTime = new Date(expiration);

      return (expiration && currentTime >= expirationTime)
        ? fetchAuthToken(baseAuthUrl, yyy)
        : localStorage.getItem('access_token');
    }
  } catch (e) {
    return undefined;
  }

  return undefined;
};

const loadAuthToken = async (baseAuthUrl, yyy) =>
  retrieveStoredAuthToken(baseAuthUrl, yyy) || await fetchAuthToken(baseAuthUrl, yyy);

const authToken = {
  fetchAuthToken,
  loadAuthToken
};

export default authToken;
